const t = {
  tag: "span",
  weight: "regular",
  italic: !1,
  display: "block"
};
export { t as textDefaultProps };